module.exports = __webpack_public_path__ + "static/media/wuyi_bg5.6c381e1c.jpg";